import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useDevice } from '../../../redux/commander/hooks/useDevice';
import { useControlUnitsById } from '../../../redux/controlUnit/hooks/useControlUnitsById';
import PanControlUnitFryer from './PanControlUnitFryer';
import useWatchError from '../../../handlingErrors/useWatchError';

interface FryerPanProps {
  deviceId: string;
  isLoadingComposableDevice: boolean;
}

export default function FryerPan(props: FryerPanProps) {
  const { deviceId, isLoadingComposableDevice } = props;

  /** Init Groups */
  const {
    data: device,
    error: devicesError,
    isLoading: loadingDevices,
  } = useDevice(deviceId);
  const {
    data: controlUnits,
    error: controlUnitsError,
    isLoading: loadingControlUnits,
  } = useControlUnitsById({
    deviceId: deviceId,
    hideCommander: true,
  });
  useWatchError(controlUnitsError || devicesError);
  const loading =
    loadingDevices || loadingControlUnits || isLoadingComposableDevice;

  return (
    <Box minHeight="625px" flex={1}>
      {loading ? (
        <div>
          <Box display="flex" alignItems="center" justifyContent="center">
            <CircularProgress />
          </Box>
        </div>
      ) : controlUnits && controlUnits.length > 0 ? (
        controlUnits.slice(0, 1).map((cu, index) => (
          <Box key={cu.id.concat(index.toString())} flex={1}>
            <PanControlUnitFryer
              deviceName={cu.name ?? device?.name}
              controlUnit={cu}
              deviceId={deviceId}
            />
          </Box>
        ))
      ) : null}
    </Box>
  );
}
